import React, { useState, useEffect, useRef } from "react";
import {
    Row,
    Col,
    Typography,
    Button,
    message,
    Form,
} from "../../ui/ot";
import NewArrivalsListForm from "./new_arrivals_list_form";
import { useCRUDController } from "../../ui/classify_structure/CRUDController";
import { useTranslation } from "react-i18next";
import { useSearchParams, useNavigate } from "react-router-dom";
import dayjs from 'dayjs';

const NewArrivalsListEdit = ({
    keyPrefix = "library.backstage.new_arrivals_list_management",
}) => {
    const navigate = useNavigate()
    const { t } = useTranslation('translation', { keyPrefix })
    const [searchParams, setSearchParams] = useSearchParams();
    const list_id = searchParams.get('list_id');
    const mode = searchParams.get('mode');
    const [form] = Form.useForm();
    const [reloadCount, setReloadCount] = useState(0)
    const onFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === "post") {
                message.success(t('add_success'));
                navigate(`../new_arrivals_list_management?mode=edit&list_id=${values?.list_id}`)
            } else if (axiosMode === "patch") {
                message.success(t('modify_success'));
                if (list_id) {
                    dataReload(list_id)
                }
            } else if (axiosMode === "delete") {
                message.success(t('delete_success'));
            }
        } else if (status === "error") {
            if (axiosMode === "post") {
                message.error(t('add_failure'));
            } else if (axiosMode === "patch") {
                message.error(t('modify_failure'));
            } else if (axiosMode === "delete") {
                message.error(t('delete_failure'));
            }
        }
        if (axiosMode !== "get") {
        }

    };
    const onBefore = ({ axiosMode, status, values }) => {
        // setModalLoading(true);
    };
    const onFormFinish = (value) => {
        if (mode === "new") {
            NewBibDisplayController.postData([
                value
            ])
        }
        else if (mode === "edit") {
            NewBibDisplayController.patchData([
                value
            ])
        }
    }
    const dataReload = (list_id) => {
        NewBibDisplayController.getData({
            list_id: list_id
        }).then((response) => {
            let data = response?.data || []
            let firstData = data.find((ele) => true)
            let bibs_list_items_data = (firstData?.bibs_list_items_data || [])?.map((bibValue) => {
                return {
                    ...bibValue,
                    bib_biblionumber: bibValue?.biblionumber
                }
            })
            form.setFieldsValue({
                ...firstData,
                bibs_list_items_data
            })
            setReloadCount((pre) => pre + 1)
        })
    }
    const NewBibDisplayController = useCRUDController({
        apiRoute: "/library/newbib_display",
        onFinish,
        onBefore
    })

    useEffect(() => {
        if (list_id) {
            dataReload(list_id)
        }
    }, [list_id])

    return (
        <Row gutter={[10, 20]} >
            <Col span={24}>
                <Row justify="space-between">
                    <Col>
                        <Typography.Title level={2}>{t('')}</Typography.Title>
                    </Col>
                    <Col>
                        <Row gutter={[8, 8]}>
                            <Col>
                                <Button
                                    onClick={() => {
                                        navigate(`../new_arrivals_list_management`)
                                    }}
                                    type="default" >
                                    {t('cancel')}
                                </Button>
                            </Col>
                            <Col>
                                <Button
                                    onClick={() => {
                                        form.submit()
                                    }}
                                >
                                    {t('save')}
                                </Button>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Col>
            <Col span={24}>
                <NewArrivalsListForm
                    propsForm={form}
                    onFormFinish={onFormFinish}
                    propsReloadCount={reloadCount}
                />
            </Col>

        </Row>
    );
};
export default NewArrivalsListEdit;
